import React, { useEffect } from "react";

export default function Redirect({url = ""}) {

    useEffect(() => {
        window.location.replace(url);
    }, [url]);

    return (
        <div className="w-screen h-screen fixed top-0 left-0 bg-white flex-center">
            <h5>در حال انتقال ...</h5>
        </div>
    );
};
